// Portfolio Data - Krishnanshu Bhadauria

export const personalInfo = {
  name: "Krishnanshu Bhadauria",
  title: "Data Analyst",
  tagline: "Transforming raw data into actionable insights",
  email: "kbhadauria.work@gmail.com",
  phone: "+917248200359",
  linkedin: "https://linkedin.com/in/krishnanshu-bhadauria",
  github: "https://github.com/krishnanshubhadauria",
  location: "Gurugram, India",
  bio: "A passionate Data Analyst and AI Engineer with hands-on experience in end-to-end analytics workflows. Skilled in transforming complex datasets into strategic business insights through Python, SQL, and Power BI. Recently graduated from B.Tech in CSE (AI & ML) with a strong foundation in data-driven decision making.",
  resumeUrl: "https://drive.google.com/file/d/1s-UXTUwfAERBNSJPc6SQpstBQU5DgxtA/view?usp=sharing" // Updated with actual resume URL
};

export const stats = [
  { value: "10+", label: "Projects Completed", description: "End-to-end analytics" },
  { value: "5M+", label: "Data Points Analyzed", description: "Across various datasets" },
  { value: "99.34", label: "Percentile Score", description: "Naukri Young Turks" },
  { value: "30+", label: "Students Mentored", description: "At Ardema Tech Club" }
];

export const services = [
  {
    id: 1,
    title: "Data Analysis & EDA",
    description: "Comprehensive exploratory data analysis to uncover patterns, trends, and insights from your data using Python and statistical methods.",
    features: ["Statistical Analysis", "Pattern Recognition", "Trend Identification", "Outlier Detection"]
  },
  {
    id: 2,
    title: "Dashboard Development",
    description: "Interactive Power BI and Excel dashboards that transform complex data into clear, actionable visualizations for stakeholders.",
    features: ["Power BI Dashboards", "KPI Tracking", "Real-time Updates", "Custom Visualizations"]
  },
  {
    id: 3,
    title: "SQL & Database Analysis",
    description: "Expert SQL querying for data extraction, transformation, and analysis from complex database systems.",
    features: ["Complex Queries", "ETL Pipelines", "Data Modeling", "Performance Optimization"]
  },
  {
    id: 4,
    title: "Business Intelligence",
    description: "Strategic insights and reporting that drive business decisions through comprehensive data storytelling.",
    features: ["KPI Reporting", "Market Analysis", "Customer Segmentation", "Revenue Analytics"]
  }
];

export const processSteps = [
  {
    step: "01",
    title: "Data Collection",
    description: "Gathering data from multiple sources including databases, APIs, and spreadsheets while ensuring data quality."
  },
  {
    step: "02",
    title: "Data Cleaning",
    description: "Handling missing values, removing duplicates, and standardizing formats to prepare analysis-ready datasets."
  },
  {
    step: "03",
    title: "Exploratory Analysis",
    description: "Statistical analysis and visualization to understand data distributions, correlations, and patterns."
  },
  {
    step: "04",
    title: "Insight Generation",
    description: "Deriving actionable insights through advanced analytics, hypothesis testing, and trend analysis."
  },
  {
    step: "05",
    title: "Visualization",
    description: "Creating compelling dashboards and reports that communicate findings effectively to stakeholders."
  },
  {
    step: "06",
    title: "Recommendations",
    description: "Providing data-driven recommendations and strategies to optimize business outcomes."
  }
];

export const toolsDetailed = [
  { name: "Python", category: "Language", proficiency: 90, icon: "code" },
  { name: "SQL", category: "Language", proficiency: 85, icon: "database" },
  { name: "Power BI", category: "BI Tool", proficiency: 85, icon: "bar-chart" },
  { name: "Excel", category: "Spreadsheet", proficiency: 90, icon: "table" },
  { name: "Pandas", category: "Library", proficiency: 90, icon: "layers" },
  { name: "NumPy", category: "Library", proficiency: 85, icon: "calculator" },
  { name: "Matplotlib", category: "Visualization", proficiency: 80, icon: "line-chart" },
  { name: "Seaborn", category: "Visualization", proficiency: 80, icon: "pie-chart" },
  { name: "PostgreSQL", category: "Database", proficiency: 75, icon: "server" },
  { name: "Git", category: "Version Control", proficiency: 80, icon: "git-branch" },
  { name: "Jupyter", category: "IDE", proficiency: 90, icon: "file-code" },
  { name: "AWS", category: "Cloud", proficiency: 65, icon: "cloud" }
];

export const dashboardShowcase = [
  {
    id: 1,
    title: "Sales Performance Dashboard",
    description: "Real-time sales tracking with KPIs, regional performance, and trend analysis",
    metrics: ["Revenue Growth: +23%", "Top Region: North", "Best Product: Category A"],
    tools: ["Power BI", "SQL", "DAX"]
  },
  {
    id: 2,
    title: "Customer Analytics Dashboard",
    description: "Customer segmentation, behavior analysis, and retention metrics visualization",
    metrics: ["Retention Rate: 85%", "Avg. Order Value: $127", "Active Users: 15K"],
    tools: ["Python", "Power BI", "Excel"]
  },
  {
    id: 3,
    title: "Inventory Management Dashboard",
    description: "Stock levels, vendor performance, and supply chain optimization metrics",
    metrics: ["Stock Turnover: 4.2x", "Vendor Score: 92%", "Cost Savings: $2.7M"],
    tools: ["SQL", "Power BI", "Python"]
  }
];

export const skills = {
  languages: [
    { name: "Python", level: 90 },
    { name: "SQL", level: 85 }
  ],
  libraries: [
    { name: "Pandas", level: 90 },
    { name: "NumPy", level: 85 },
    { name: "Matplotlib", level: 80 },
    { name: "Seaborn", level: 80 }
  ],
  biTools: [
    { name: "Power BI", level: 85 },
    { name: "DAX", level: 75 },
    { name: "Power Query", level: 80 },
    { name: "Excel", level: 90 }
  ],
  analytics: [
    "Data Cleaning",
    "Exploratory Data Analysis",
    "KPI Reporting",
    "Customer Segmentation",
    "Trend Analysis",
    "Hypothesis Testing"
  ],
  tools: [
    "Jupyter Notebook",
    "Git/GitHub",
    "AWS Cloud",
    "RPA"
  ]
};

export const projects = [
  {
    id: 1,
    title: "Vendor Performance Analysis",
    subtitle: "Retail Inventory & Sales",
    description: "Analyzed vendor efficiency and profitability to support strategic purchasing and inventory decisions. Built SQL ETL pipeline using CTEs for large datasets processing.",
    highlights: [
      "Identified top 10 vendor dependency (65.7%)",
      "Uncovered $2.71M unsold inventory",
      "72% cost reduction through bulk purchasing insights"
    ],
    technologies: ["SQL", "Python", "Power BI"],
    category: "Business Intelligence",
    impact: "$2.71M inventory optimization",
    url: "https://github.com/krishnanshubhadauria/vendor_performance_analysis_Python_SQL_PowerBI"
  },
  {
    id: 2,
    title: "Customer Shopping Behavior Analysis",
    subtitle: "Segmentation & Sales Trends",
    description: "Analyzed customer purchasing patterns and spending behavior to support data-driven marketing and retention decisions.",
    highlights: [
      "Customer segmentation based on spending behavior",
      "Purchase frequency analysis",
      "Category-wise sales trend visualization"
    ],
    technologies: ["SQL", "Python", "Power BI", "PostgreSQL"],
    category: "Customer Analytics",
    impact: "15% improvement in targeting",
    url: "https://github.com/krishnanshubhadauria/customer_behavior_analysis_python_sql_powerBI"
  }
];

export const experience = [
  {
    id: 1,
    company: "365Data Science",
    role: "Data Analytics Intern",
    type: "Virtual Internship",
    duration: "Sep 2025 - Dec 2025",
    responsibilities: [
      "Applied end-to-end Data Analytics workflows including data cleaning, preprocessing, and EDA using Python",
      "Executed analytical SQL queries (joins, aggregations, grouping) to extract insights and support KPI-based reporting",
      "Built interactive Power BI dashboards using data modeling and DAX for improved data storytelling"
    ]
  },
  {
    id: 2,
    company: "IBM Skill Build",
    role: "AI Engineer Intern",
    type: "Virtual Internship",
    duration: "Jul 2025 - Aug 2025",
    responsibilities: [
      "Built chatbots and explored Agentic AI, including designing and deploying agents on watsonx",
      "Implemented LangChain workflows and RAG pipelines to improve response accuracy",
      "Developed foundations in Cloud fundamentals, Prompt Engineering, and Data Analytics"
    ]
  }
];

export const education = {
  institution: "ABES Engineering College, Ghaziabad",
  degree: "B.Tech, CSE (AI & ML)",
  duration: "2021 - 2025"
};

export const certifications = [
  {
    id: 1,
    name: "Oracle Cloud Infrastructure 2025",
    issuer: "Oracle",
    credential: "Certified Data Science Professional",
    year: "2025"
  }
];

export const achievements = [
  {
    id: 1,
    title: "99.34 Percentile",
    description: "Naukri Campus Young Turks 2025 (Data Science Cluster)"
  },
  {
    id: 2,
    title: "Community Impact",
    description: "Recognized for improving literacy in underserved communities at HUHC (NGO)"
  },
  {
    id: 3,
    title: "Tech Leadership",
    description: "Organized 3+ hackathons, mentored 30+ students at Ardema Tech Club"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Mentor at 365Data Science",
    role: "Senior Data Analyst",
    content: "Krishnanshu demonstrated exceptional analytical skills and a keen eye for detail. His ability to translate complex data into actionable insights impressed our entire team.",
    rating: 5
  },
  {
    id: 2,
    name: "Project Supervisor",
    role: "IBM Skill Build Program",
    content: "Outstanding work on AI implementations. Krishnanshu's technical proficiency combined with his problem-solving approach made him stand out among his peers.",
    rating: 5
  }
];

export const faqs = [
  {
    question: "What types of data analysis projects do you work on?",
    answer: "I specialize in business intelligence, customer analytics, sales analysis, and inventory optimization. My expertise spans across Python-based statistical analysis and Power BI dashboard development."
  },
  {
    question: "What tools and technologies do you use?",
    answer: "I primarily work with Python (Pandas, NumPy, Matplotlib), SQL (PostgreSQL), Power BI (DAX, Power Query), and Excel. I'm also familiar with cloud platforms like AWS."
  },
  {
    question: "Can you create custom dashboards for my business?",
    answer: "Absolutely! I create interactive Power BI dashboards tailored to your specific KPIs and business needs, with real-time data connectivity and intuitive visualizations."
  },
  {
    question: "What is your typical project workflow?",
    answer: "My workflow includes: Data Collection → Cleaning & Preprocessing → Exploratory Analysis → Insight Generation → Visualization → Recommendations. Each step is documented and collaborative."
  }
];

export const navLinks = [
  { name: "About", href: "#about" },
  { name: "Skills", href: "#services" },
  { name: "Projects", href: "#projects" },
  { name: "Experience", href: "#experience" },
  { name: "Contact", href: "#contact" }
];